<template>
  <MainLayout>
    <div class="section-hero">
      <div class="lg:min-h-[250px] min-h-[200px] w-full flex justify-center items-center gap-3 flex-col">
        <h1 class="lg:text-5xl text-3xl text-white font-primary font-bold">Disclaimer</h1>
        <!-- <div class="lg:text-lg text-sm text-white">Last updated: January 01, 2020</div> -->
      </div>
    </div>
    <div class="container mx-auto px-3 lg:py-10 py-5 shadow-md ">
      <!-- <p class="font-semibold text-xl">Effective Date: [January 01, 2020]</p> -->
      <div class="p-5">
        <!-- <h2 class="text-lg font-semibold ">
          Disclaimer

        </h2> -->
        <p class="py-4">
          To the maximum extent permitted by applicable law, we exclude all representations, warranties and conditions
          relating to our website and the use of this website. Nothing in this disclaimer will:

        </p>
        <ul class="list-disc py-4 px-5">
          <li>Limit or exclude our or your liability for death or personal injury.</li>
          <li>limit or exclude our or your liability for fraud or fraudulent misrepresentation.</li>
          <li>limit any of our or your liabilities in any way that is not permitted under applicable law.</li>
          <li>exclude any of our or your liabilities that may not be excluded under applicable law.</li>
        </ul>
        <p class="py-4">
          The limitations and prohibitions of liability set in this Section and elsewhere in this disclaimer: (a) are
          subject to the preceding paragraph; and (b) govern all liabilities arising under the disclaimer, including
          liabilities arising in contract, in tort and for breach of statutory duty.
        </p>
        <p class="py-4">
          As long as the website and the information and services on the website are provided free of charge, we will not
          be liable for any loss or damage of any nature.
        </p>

      </div>
    </div>
  </MainLayout>
</template>

<style scoped>
.section-hero {
  background-image: linear-gradient(rgba(0, 92, 255, 0.8), rgba(0, 92, 255, 0.8)), url("../../assets/v-1.1/Banners/blue-bg.png");
  border-bottom-left-radius: 50% 40px;
  border-bottom-right-radius: 50% 40px;
  background-size: cover;
  background-repeat: no-repeat;
  margin-top: 5.5rem;
}
</style>
